// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NVn-L","title":"styles_title__HF0gY","content":"styles_content__hQZ1w"};